import React, { useState } from "react";
import { FaFacebook, FaGooglePlus, FaInstagram, FaRss, FaTimes, FaTwitter } from "react-icons/fa";
import { Col, Container, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Teamdata } from "../Data/ComponentsData/componentsdata";

const Team = () => {
  const [activeTeamIndex, setActiveTeamIndex] = useState(null);

  const showTeamDetails = (i) => {
    setActiveTeamIndex(i + 1);    
  };

  const closeTeamDetails = () => {
    setActiveTeamIndex(null);
  };

  return (
    <section className='team-bg' id='team'>
      <div className='animation-circle-inverse'>
        <i></i>
        <i></i>
        <i></i>
      </div>
      <Container>
        <Row>
          <Col md='12' className='text-center'>
            <div className='section-title'>
              <h2>Our Work Place</h2>
              <img src='assets/images/title-line.png' alt='title-line' className='img-fluid' />
            </div>
          </Col>
          <Col md='12'>
            <Swiper
              spaceBetween={30}
              slidesPerView={3}
              // centeredSlides={true}
              loop={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              pagination={{ clickable: true }}
              navigation={false}
              breakpoints={{
                992: {
                  slidesPerView: 3,
                },
                576: {
                  slidesPerView: 2,
                },
                0: {
                  slidesPerView: 1,
                },
              }}
            >
              {Teamdata.map((val, i) => (
                <SwiperSlide key={i + 1}>
                  <div className={`team-box ${activeTeamIndex ? "d-none" : ""}`}>
                    <div className='team-under-box'>
                      <div className='team-under-box-button text-white' onClick={() => showTeamDetails(i)}>
                        <i className='fa fa-plus' aria-hidden='true'></i>
                      </div>
                      <img src={`assets/images/${val.photo}`} alt='1' className='img-fluid' />
                      <div className='team-overlay'>
                        <div className='social-icon'>
                          <ul>
                            <li><a href={val.facebook}><FaFacebook /></a></li>
                            <li><a href={val.google}><FaGooglePlus /></a></li>
                            <li><a href={val.twitter}><FaTwitter /></a></li>
                            <li><a href={val.instagram}><FaInstagram /></a></li>
                            <li><a href={val.rss}><FaRss /></a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {Teamdata.map((value, index) => (
              <Col md='12' key={index}>
                {activeTeamIndex === index + 1 && (
                  <div className={`team-hover team-hover-${index}`}>
                    <Row>
                      <Col md='4'>
                        <div className='team-profile'>
                          <img src={`assets/images/${value.photo}`} alt='1' className='img-fluid' />
                        </div>
                      </Col>
                      <Col md='8'>
                        <div className='d-flex-1'>
                          <div className='hover-text'>
                            <div className='team-close-btn'>
                              <FaTimes onClick={closeTeamDetails}/>
                            </div>
                            <h3>{value.name}</h3>
                            <h4 className='m-0 text-muted'>{value.designation}</h4>
                            <h5>PHP, Laravel, Cake , Wordpress, HTML5</h5>
                            <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text,</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Team;
